import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/**
 * Decode a folder path from a URL search param.
 * Handles tilde-encoding (~XX → %XX) used by some routing frameworks
 * (e.g., scio1 encodes `/` as `~2F` instead of `%2F`).
 * Safe to call multiple times (idempotent) — only decodes when tilde-encoding is present.
 */
export function decodeFolderPath(raw: string): string {
  // Only decode if tilde-encoding is present to avoid double-decoding
  if (!/~[0-9A-Fa-f]{2}/.test(raw)) return raw;
  const normalized = raw.replace(/~([0-9A-Fa-f]{2})/g, '%$1');
  try {
    return decodeURIComponent(normalized);
  } catch {
    return raw;
  }
}
